// extracted by mini-css-extract-plugin
module.exports = {"container":"auth_container__QBrSx","btn":"auth_btn__38zxl","eye":"auth_eye__2uPB8","input":"auth_input__QPMxP"};